import {createWebHashHistory, createWebHistory} from 'vue-router'
import {createRouter,} from 'vue-router';
import {routes} from "@/router/routes";
import { navigationGuard } from '@okta/okta-vue';
import RouterGuards from "@/router/router-guards";
import RouterUIToggle from "@/router/routerUIToggle";
import rootStore from "@/store/RootStore";

const router = createRouter({
    //history: createWebHistory(),
    history: createWebHashHistory(),
    routes: routes
});


//router.beforeEach(navigationGuard);
router.beforeEach((to, from, next) => {
    const appVersion = rootStore.getInstance().appConfigStore.getVersion();

    if (to.query.v !== appVersion) {
        next({ path: to.path, query: { ...to.query, v: appVersion } });
    } else {
        next();
    }
});

export default router
export const routerUIToggle = new RouterUIToggle(router, new RouterGuards());
